import { Link } from "react-router-dom";
import { SOLUTIONS } from "@/config/site";

export default function Marquee() {
  return (
    <div
      className="marquee-hover overflow-hidden border-y border-silver/50 bg-platinum py-6"
      data-testid="solutions-marquee"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <ul
            key={copy}
            aria-hidden={copy === 1}
            className="flex shrink-0 items-center"
          >
            {SOLUTIONS.map((s) => (
              <li key={s.id} className="flex items-center">
                <Link
                  to={`/solutions/${s.slug}`}
                  tabIndex={copy === 1 ? -1 : undefined}
                  data-testid={`marquee-link-${s.slug}`}
                  className="group flex items-baseline gap-3 px-8"
                >
                  <span className="font-display text-xs font-bold text-cobalt">{s.num}</span>
                  <span className="whitespace-nowrap font-display text-lg font-semibold text-ink/80 transition-colors group-hover:text-cobalt">
                    {s.name}
                  </span>
                </Link>
                <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-cobalt/50" />
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
}
